import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getShiftRequestIdLogs } from "../../slice/workerResumeSlice";

const WorkerShiftRequestLogs = () => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const token = localStorage.getItem("token");
    const { shiftRequstIdLogs, loading, error } = useSelector(
        (state) => state.workerResume
    );

    useEffect(() => {
        if (!token) return;

        dispatch(getShiftRequestIdLogs({ id, token }));
    }, [id, token, dispatch]);


    console.log("shiftRequstIdLogs", shiftRequstIdLogs);

    return (
        <>
            <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
                <div className="ps-2 ps-lg-4">
                    <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">
                        Work Hours Details
                    </h4>

                    <div className="row g-3">
                        <div className="col-12">

                            {/* 🔄 Loading */}
                            {loading && (
                                <div className="d-flex justify-content-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            )}

                            {/* ❌ Error */}
                            {error && (
                                <div className="alert alert-danger text-center">
                                    {error}
                                </div>
                            )}

                            {/* 📭 No Data */}
                            {!loading &&
                                !error &&
                                (!shiftRequstIdLogs || shiftRequstIdLogs.length === 0) && (
                                    <div className="alert alert-info text-center">
                                        No data found
                                    </div>
                                )}

                            {/* 📊 Table */}
                            {!loading &&
                                !error &&
                                shiftRequstIdLogs &&
                                shiftRequstIdLogs.length > 0 && (
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">Check-in Date</th>
                                                    <th scope="col">Check-in Time</th>
                                                    <th scope="col">Check-out Date</th>
                                                    <th scope="col">Check-out Time</th>
                                                    <th scope="col">Hours Worked</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {shiftRequstIdLogs.map((log, index) => (
                                                    <tr key={log.id}>
                                                        <td>{log.check_in_date || "-"}</td>
                                                        <td>{log.check_in_time || "-"}</td>
                                                        <td>{log.check_out_date || "-"}</td>
                                                        <td>{log.check_out_time || "-"}</td>
                                                        <td>{log.hours_worked || "-"}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}
export default WorkerShiftRequestLogs;